import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';
import { CanDeactivateGuard } from '../../gards/can-deactivate-guard.service';

export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.FR.MATERIALS,
    loadComponent: () =>
      import('./materials.component').then((m) => m.MaterialsComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.MATERIALS + '/:slug/:id',
    loadComponent: () =>
      import('./material/material.component').then((m) => m.MaterialComponent),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.MATERIALS,
    loadComponent: () =>
      import('./materials.component').then((m) => m.MaterialsComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.MATERIALS + '/:slug/:id',
    loadComponent: () =>
      import('./material/material.component').then((m) => m.MaterialComponent),
    canDeactivate: [CanDeactivateGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MaterialsModule {}
